export function error(err, customAttributes = {}, notifyNR = true) {
	if (notifyNR) {
		const newrelic = window.newrelic || window.NREUM;
		const userId = window?.ui?.getCookie('LAU');

		const outgoingError = typeof err === 'string' ? new Error(err) : err;
		newrelic?.noticeError?.(outgoingError, { sourceApp: 'hintsui-eval', level: 'error', userId, ...customAttributes });
	}

	console.error(err); // eslint-disable-line no-console
}

export function warn(message, customAttributes = {}) {
	const userId = window?.ui?.getCookie('LAU');
	const newrelic = window.newrelic || window.NREUM;
	newrelic?.noticeError?.(message, { sourceApp: 'hintsui-eval', level: 'warn', userId, ...customAttributes });
}

export function info(message, customAttributes = {}) {
	const userId = window?.ui?.getCookie('LAU');
	const newrelic = window.newrelic || window.NREUM;
	newrelic?.noticeError?.(message, { sourceApp: 'hintsui-eval', level: 'info', userId, ...customAttributes });
}

export default { error, warn, info };
